import { render } from "./GroupAccessManagement.vue?vue&type=template&id=2679aa56"
import script from "./js/groupAccessManagement.js?vue&type=script&lang=js&external"
export * from "./js/groupAccessManagement.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__